import { render, staticRenderFns } from "./specList.vue?vue&type=template&id=594d600e&scoped=true"
import script from "./specList.vue?vue&type=script&lang=js"
export * from "./specList.vue?vue&type=script&lang=js"
import style0 from "./specList.vue?vue&type=style&index=0&id=594d600e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594d600e",
  null
  
)

export default component.exports